import { Box, Container, Grid2, Typography } from "@mui/material"
import { HistoryList } from "components/History/HistoryList"
import { ProjectInfos } from "components/ProjectInfos/ProjectInfos"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { allExaminations } from "utils/allExaminations"
import { Examination } from "../../graphql/types"
import { useQuery } from "@apollo/client"
import { GET_EXAMINATION_HISTORY } from "../../graphql/queries"

export const AuditTrailPage = () => {
  const { projectID, examinationID } = useParams()
  const [examination, setExamination] = useState<Examination | null>(null)

  const projectsState = useStoreState((state) => state.projects)
  const fetchProjects = useStoreActions((actions) => actions.fetchProjects)

  // Query the new separate History collection
  const { data: historyData, loading: historyLoading, error: historyError, refetch: refetchHistory } = useQuery(GET_EXAMINATION_HISTORY, {
    variables: {
      examinationId: examinationID,
      page: 0,
      pageSize: 100, // Get more entries for now
    },
    skip: !examinationID,
    errorPolicy: 'all', // Continue even if there are GraphQL errors
  })

  useEffect(() => {
    // Fetch fresh project data to get examination details (but not history)
    const loadAuditTrail = async () => {
      console.log("Loading audit trail - fetching fresh project data...")
      await fetchProjects({ fresh: true })
    }
    
    loadAuditTrail()
  }, [fetchProjects, projectID, examinationID])

  useEffect(() => {
    const project = projectsState.find((project) => projectID === project.id)
    if (project) {
      const exam = allExaminations(project).find((examination) => examination.id === examinationID)

      if (exam) {
        console.log("Found examination for audit trail:", exam)
        // Use history from the new query instead of embedded history
        const historyItems = historyData?.examinationHistory?.items || []
        console.log("History from new query:", historyItems)
        
        const examinationWithNewHistory = {
          ...exam,
          history: historyItems, // Use the new history data
        }
        setExamination(examinationWithNewHistory)
      } else {
        console.log("No examination found for ID:", examinationID)
        console.log(
          "Available projects:",
          projectsState.map((p) => ({ id: p.id, name: p.name }))
        )
      }
    }
  }, [examinationID, projectID, projectsState, historyData])

  // Show history error if there's an issue with the history query
  if (historyError) {
    console.error("History query error:", historyError)
  }

  return (
    <Container maxWidth="md" sx={{ p: 0 }}>
      {(!examination || historyLoading) && (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="body2" color="text.secondary">
            {historyLoading ? "Audit-Trail wird geladen..." : "Prüfung wird geladen..."}
          </Typography>
        </Box>
      )}

      {historyError && (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="body2" color="error">
            Error loading audit trail: {historyError.message}
          </Typography>
        </Box>
      )}

      {examination && !historyLoading && (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <ProjectInfos examination={examination} />

            <HistoryList history={examination.history} />
          </Grid2>
        </Grid2>
      )}
    </Container>
  )
}
